import React from 'react';
import BottomNavBar from 'components/local/navbar/BottomNavBar';
import StockSummary from 'containers/inProgressPage/subcomponents/stock/StockSummary';
import { useHandleRequest } from 'containers/inProgressPage/hooks/useHandleRequest';
import { useTranslation } from 'react-i18next';

const PostStock = ({ currentSlot, startingBalance }) => {
  const { t } = useTranslation();
  const { handleSubmitSlot } = useHandleRequest();
  const { child_count } = currentSlot;

  return (
    <>
      <StockSummary
        currentSlot={currentSlot}
        startingBalance={startingBalance}
      />
      <BottomNavBar
        handleClick={() => handleSubmitSlot()}
        buttonText={child_count ? 'ANSWER QUESTIONS' : t('buttons.next')}
        background="#dfddda"
        flat={true}
      />
    </>
  );
};

export default PostStock;
